<template>
  <i v-on="$listeners" :class="iconClasses">      
  </i>
</template>

<script>
const name = 'i8-icon';
// Internet Explorer 6-11
const isIE = /*@cc_on!@*/ false || !!document.documentMode;
// Convention sprite-${size}--${modifier}
export default {
    name,

    props: {
        icon: '',
        size: '',
        colour: '',
    },
    computed: {
        iconClasses() {         
            // Removing spritesheet - It is iconv2 for now to prevent clashes while doing this migration
            return {
                [`iconv2 iconv2-${this.iconNameWithSize}`]: true,
                [`iconv2-${this.iconNameWithSize}--${this.colour}`]: this.colour,
            };
        },
        // Append the size 
        iconNameWithSize() {
            return this.size ? `${this.icon}-${this.size}` : this.icon;
        },
    },
};
</script>



// WEBPACK FOOTER //
// shared/components/I8Icon.vue